export const CITIZENSHIP_TYPE = [
  {
    label: 'US Citizen',
    value: 'CITIZEN',
  },
  {
    label: 'US Permanent Resident',
    value: 'PERMANENT_RESIDENT',
  },
  {
    label: 'Alien',
    value: 'NON_RESIDENT_ALIEN',
  },
  {
    label: 'Non-permanent Resident Alien',
    value: 'NON_PERMANENT_RESIDENT_ALIEN',
  },
];

export const PERMANENT_RESIDENT = 'PERMANENT_RESIDENT';
export const NON_PERMANENT_RESIDENT_ALIEN = 'NON_PERMANENT_RESIDENT_ALIEN';
